(function () {
  const waitForForm = setInterval(() => {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    clearInterval(waitForForm);

    const idInput = form.querySelector('input[name="id"]');
    const addButton = form.querySelector('button[name="add"]');

    if (!idInput || !addButton) return;

    let lastValue = idInput.value;

    // OBSERVA CAMBIOS EN EL ID DE VARIANTE
    const observer = new MutationObserver(() => {
      if (idInput.value !== lastValue) {
        lastValue = idInput.value;

        //FORZAR ACTIVACIÓN DEL BOTÓN
        addButton.disabled = false;
        addButton.classList.remove('disabled');
      }
    });

    observer.observe(idInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }, 200);
})();
